import { Link, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useState } from "react";
import DisplayEmptyListAction from "../../../../../../components/DisplayEmptyListAction";
import { useModalDetalheTitulo } from "../../../MIContasReceber/ModalDetalheTituloContext";
import { PaperBox } from "../../../../../../components/Layout/PaperBox";
import useSetParamsURL from "../../../../../../lib/useSetParamsURL";

export default function TitulosCompensados({ codigo, titulos }: TitulosCompensadosProps) {

    const { openModal } = useModalDetalheTitulo()
    const { clearSingleParamUrl } = useSetParamsURL();

    const handleCalStep = () => {
        if (!titulos) return 0
        return titulos.findIndex(item => item.codigo === codigo)
    }
    const [activeStep] = useState(handleCalStep());

    return (
        <PaperBox>
            <Typography variant="h6"><b>Títulos utilizados na compensação</b></Typography>
            {
                (titulos?.length === 0) && (
                    <DisplayEmptyListAction
                        disabled
                        label="Nenhum título encontrado"
                    />
                )
            }

            {
                titulos &&
                <Stepper activeStep={activeStep} orientation="vertical">
                    {
                        titulos.map((step) => {
                            return (
                                <Step key={step.codigo} completed={false}>
                                    <StepLabel>
                                        <Typography variant="subtitle2">
                                            <Link
                                                onClick={() => {
                                                    clearSingleParamUrl("detalhe-titulo-pagar");
                                                    openModal(step.codigo);
                                                }}
                                                sx={{ cursor: "pointer" }}
                                            >
                                                {step.codigo}
                                            </Link>
                                        </Typography>
                                    </StepLabel>
                                </Step>
                            )
                        })
                    }
                </Stepper>
            }
        </PaperBox>
    )
}


interface TitulosCompensadosProps {
    codigo: string;
    titulos?: Array<{
        codigo: string;
    }>
}